/**
 * Generic fallback BISAC mappings for Thema top-level categories.
 * Only used as a last resort when the standard mapping produces no matches.
 * Codes are matched by first letter, so e.g. "FQ", "DNP", "YF" all
 * resolve via their top-level letter (F, D, Y).
 */
const themaFallbackBisac = {
	A: "ART000000", // The Arts
	C: "LAN000000", // Language & Linguistics
	D: "LIT000000", // Literature & Literary Studies
	F: "FIC000000", // Fiction
	G: "REF000000", // Reference, Information & Interdisciplinary
	J: "SOC000000", // Society & Social Sciences
	K: "BUS000000", // Economics, Finance, Business & Management
	L: "LAW000000", // Law
	M: "MED000000", // Medicine & Nursing
	N: "HIS000000", // History & Archaeology
	P: "MAT000000", // Mathematics & Science
	Q: "PHI000000", // Philosophy & Religion
	R: "SCI000000", // Earth Sciences, Geography, Environment
	S: "SPO000000", // Sports & Active outdoor recreation
	T: "TEC000000", // Technology, Engineering, Agriculture
	U: "TRV000000", // Travel & Holiday
	V: "SEL000000", // Health, Relationships & Personal development
	W: "HOM000000", // Lifestyle, Hobbies & Leisure
	Y: "JUV000000", // Children's, Teenage & Educational
};

export default themaFallbackBisac;
